import { render, staticRenderFns } from "./ModalReplies.vue?vue&type=template&id=73f71aae&scoped=true"
import script from "./ModalReplies.vue?vue&type=script&lang=js"
export * from "./ModalReplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f71aae",
  null
  
)

export default component.exports